export const DangerSignIcon = ({ size = 18, color = "black", classNames, ...props }) => (
 <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`feather feather-alert-triangle me-2 icon-sm ${classNames}`}>
  <path stroke={color} d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
  <line stroke={color} x1="12" y1="9" x2="12" y2="13"></line>
  <line stroke={color} x1="12" y1="17" x2="12.01" y2="17"></line>
 </svg>
);